/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import moment from 'moment'

import { API, MEDIAMANAGERDOWNLOADAPI } from '../api/api'
import { fetch, post, put } from '../api/httpClient'
import localStorageService from '../api/localStorageService'
import { DATEFORMATWITHTIME, MESSAGE_SEVERITIES } from '../helpers/constants'
import { selectApp } from '../helpers/selectors'
import { formatDate, get, isEmpty } from '../helpers/utils'
import { messageAction } from './app.action'

// Tickets Action
export const fetchTicketsApi = (pageDetail, successCallback, failureCallback) => async () => {
  const { page, per_page, sortOrder, sortBy } = pageDetail

  const url = `${API.tms.ticketManager}?sortBy=${sortBy || ''}&sortOrder=${
    sortOrder || ''
  }&perPage=${per_page || ''}&page=${page || ''}`

  try {
    const { data } = await fetch(url)
    get(data, 'content.tickets', []).forEach((item) => modifyTicketListItem(item))
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (
      typeof failureCallback === 'function' &&
      ![404, 403, 401, 408, 500].includes(err.response.status)
    ) {
      failureCallback(err)
    }
  }
}

export const fetchTicketByIdCall = (id, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.tms.ticketManager}/${id}`
    const { data } = await fetch(url)
    modifyRequestItem(data)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchCommentByIdCall = (id, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.tms.ticketManager}/comments/get-comments?ticketId=${id}`
    const { data } = await fetch(url)
    get(data, 'content.comments', []).forEach((item) => modifyRequestItem(item))
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchHistoryByIdCall = (id, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.tms.ticketManager}/history/${id}`
    const { data } = await fetch(url)
    data.forEach((item) => modifyHistoryList(item))
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

// export const getMasterDataCall = (successCallback, failureCallback) => async () => {
//   const url = `${API.CORE.MASTER}`
//   try {
//     const { data } = await fetch(url)
//     if (typeof successCallback === 'function') {
//       successCallback(data)
//     }
//   } catch (err) {
//     if (
//       typeof failureCallback === 'function' &&
//       ![404, 403, 401, 408, 500].includes(err.response.status)
//     ) {
//       failureCallback(err)
//     }
//   }
// }

export const createTicketCall = (payload, successCallback, failureCallback) => async (dispatch) => {
  try {
    const { title, description, department, studentPublicId, media } = payload
    const url = `${API.tms.ticketManager}`

    const updatedPayload = new FormData()
    updatedPayload.append('title', title)
    updatedPayload.append('description', description)
    updatedPayload.append('department', department)
    updatedPayload.append('studentPublicId', studentPublicId)
    media.forEach((item) => {
      updatedPayload.append('file', item)
    })
    Object.keys(payload).forEach((key) => {
      if (key === 'files') {
        for (const file of payload?.files || []) {
          updatedPayload.append('media', file)
        }
      }
    })

    const { data } = await post(url, updatedPayload)
    dispatch(
      messageAction({
        subTitle: 'message:ticketCreated',
        severity: MESSAGE_SEVERITIES.SUCCESS,
      })
    )
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const updateTicketCall = (id, payload, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.tms.ticketManager}/${id}`

    const updatedPayload = new FormData()
    Object.keys(payload).forEach((key) => {
      if (key === 'files') {
        for (const file of payload?.files || []) {
          updatedPayload.append('media', file)
        }
      } else {
        updatedPayload.append(key, payload[key])
      }
    })

    const { data } = await put(url, updatedPayload)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

// Comments Action

export const addCommentCall = (payload, successCallback, failureCallback) => async (dispatch) => {
  try {
    const url = `${API.tms.ticketManager}/create-comments`

    const updatedPayload = new FormData()
    Object.keys(payload).forEach((key) => {
      if (key === 'files') {
        for (const file of payload?.files || []) {
          updatedPayload.append('media', file)
        }
      } else if (key === 'media') {
        payload.media?.length
          ? payload.media.forEach((item) => {
              updatedPayload.append('file', item)
            })
          : updatedPayload.append('file', [])
      } else {
        updatedPayload.append(key, payload[key])
      }
    })

    const { data } = await post(url, updatedPayload)
    dispatch(
      messageAction({
        subTitle: 'message:commentPublished',
        severity: MESSAGE_SEVERITIES.SUCCESS,
      })
    )
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const updateCommentCall =
  (ticketId, commentId, payload, successCallback, failureCallback) => async (dispatch) => {
    try {
      const url = `${API.tms.ticketManager}/${ticketId}/comment/${commentId}`

      const updatedPayload = new FormData()
      Object.keys(payload).forEach((key) => {
        if (key === 'files') {
          for (const file of payload?.files || []) {
            updatedPayload.append('media', file)
          }
        } else {
          updatedPayload.append(key, payload[key])
        }
      })

      const { data } = await put(url, updatedPayload)
      dispatch(
        messageAction({
          subTitle: 'message:commentUpdated',
          severity: MESSAGE_SEVERITIES.SUCCESS,
        })
      )
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const getCommentsCall = (pageDetail, successCallback, failureCallback) => async () => {
  const { q, page, sortOrder, sortBy, startDate, endDate, channel } = pageDetail

  let url = `${API.tms.ticketManager}ticket/?q=${q || ''}&sortBy=${sortBy || ''}&sortOrder=${
    sortOrder || ''
  }&perPage=${2 || ''}&page=${page || ''}&channel=${channel}`

  if (startDate) {
    url += `&startDate=${moment(startDate).format('YYYY-MM-DD')}T00:00:00`
  }
  if (endDate) {
    url += `&endDate=${moment(endDate).format('YYYY-MM-DD')}T23:59:59`
  }

  try {
    const { data } = await fetch(url)
    get(data, 'content', []).forEach((item) => modifyRequestItem(item))
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (
      typeof failureCallback === 'function' &&
      ![404, 403, 401, 408, 500].includes(err.response.status)
    ) {
      failureCallback(err)
    }
  }
}

const modifyTicketListItem = function (item) {
  if (isEmpty(item)) {
    return
  }
  // item.id = item._id
  item.createdTimeLabel = formatDate(item.createdAt, DATEFORMATWITHTIME)
  item.modifiedTimeLabel = formatDate(item.updated_at, DATEFORMATWITHTIME)
}

const modifyRequestItem = function (item) {
  if (isEmpty(item)) {
    return
  }
  // item.id = item._id
  item.createdTimeLabel = formatDate(item.createdAt, DATEFORMATWITHTIME)
  item.modifiedTimeLabel = formatDate(item.updated_at, DATEFORMATWITHTIME)
}

const modifyHistoryList = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.id = item._id
  item.createdTimeLabel = formatDate(item.created_at, DATEFORMATWITHTIME)
  item.modifiedTimeLabel = formatDate(item.updated_at, DATEFORMATWITHTIME)
  item.modifiedDueDate = formatDate(item?.due_date, DATEFORMAT)
}
export const uploadMediaCall = (payload, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.tms.ticketManager}ticket/upload-media`

    const updatedPayload = new FormData()
    updatedPayload.append('media', payload)

    const { data } = await post(url, updatedPayload)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const getMediaUrl = (url) => (_, getState) => {
  const state = getState()
  const { accountId } = localStorageService.getAccessToken()
  const app = selectApp(state)
  if (!url || !accountId || !app.baseURL) {
    return
  }
  return `${app.baseURL}${MEDIAMANAGERDOWNLOADAPI}${accountId}/default/${url}`
}
